import { Box, Divider, SvgIcon, Typography } from '@mui/material';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import PauseCircleFilledIcon from '@mui/icons-material/PauseCircleFilled';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { PeopleDetails } from './UGCCardImage';

const AudioIcon = (props) => (
  <SvgIcon {...props} style={{ fontSize: '4rem', marginTop: '-6px' }}>
    <svg width="65" height="49" viewBox="0 0 65 49" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 0.672852C4.92487 0.672852 0 5.59772 0 11.6729V37.4524C0 43.5275 4.92488 48.4524 11 48.4524H53.2852C59.3603 48.4524 64.2852 43.5275 64.2852 37.4524V11.6729C64.2852 5.59772 59.3603 0.672852 53.2852 0.672852H11ZM16.5561 37.4411C16.5561 37.9934 17.0038 38.4411 17.5561 38.4411C18.1084 38.4411 18.5561 37.9934 18.5561 37.4411L18.5561 15.4411C18.5561 14.8888 18.1084 14.4411 17.5561 14.4411C17.0038 14.4411 16.5561 14.8888 16.5561 15.4411L16.5561 37.4411ZM13.5561 36.4411C13.0038 36.4411 12.5561 35.9934 12.5561 35.4411V17.4411C12.5561 16.8888 13.0038 16.4411 13.5561 16.4411C14.1084 16.4411 14.5561 16.8888 14.5561 17.4411V35.4411C14.5561 35.9934 14.1084 36.4411 13.5561 36.4411ZM9.55609 32.4411C9.00381 32.4411 8.55609 31.9934 8.55609 31.4411V21.4411C8.55609 20.8888 9.0038 20.4411 9.55609 20.4411C10.1084 20.4411 10.5561 20.8888 10.5561 21.4411V31.4411C10.5561 31.9934 10.1084 32.4411 9.55609 32.4411ZM21.5561 34.4411C21.0038 34.4411 20.5561 33.9934 20.5561 33.4411V19.4411C20.5561 18.8888 21.0038 18.4411 21.5561 18.4411C22.1084 18.4411 22.5561 18.8888 22.5561 19.4411V33.4411C22.5561 33.9934 22.1084 34.4411 21.5561 34.4411ZM24.5561 29.4411C24.5561 29.9934 25.0038 30.4411 25.5561 30.4411C26.1084 30.4411 26.5561 29.9934 26.5561 29.4411V23.4411C26.5561 22.8888 26.1084 22.4411 25.5561 22.4411C25.0038 22.4411 24.5561 22.8888 24.5561 23.4411V29.4411ZM29.5561 34.4411C29.0038 34.4411 28.5561 33.9934 28.5561 33.4411V19.4411C28.5561 18.8888 29.0038 18.4411 29.5561 18.4411C30.1084 18.4411 30.5561 18.8888 30.5561 19.4411V33.4411C30.5561 33.9934 30.1084 34.4411 29.5561 34.4411ZM32.5561 35.4411C32.5561 35.9934 33.0038 36.4411 33.5561 36.4411C34.1084 36.4411 34.5561 35.9934 34.5561 35.4411V17.4411C34.5561 16.8888 34.1084 16.4411 33.5561 16.4411C33.0038 16.4411 32.5561 16.8888 32.5561 17.4411V35.4411ZM46.0423 16.3098C41.247 16.3098 37.3551 20.2017 37.3551 24.997C37.3551 29.7924 41.247 33.6842 46.0423 33.6842C50.8376 33.6842 54.7295 29.7924 54.7295 24.997C54.7295 20.2017 50.8376 16.3098 46.0423 16.3098ZM44.3049 21.0878L49.5172 24.997L44.3049 28.9063V21.0878Z"
        fill={props.color}
      />
    </svg>
  </SvgIcon>
);

AudioIcon.propTypes = {
  color: PropTypes.string.isRequired
};

const UgcVoiceCard = ({
  attribution,
  color,
  space,
  audioIconColor = 'black',
  playIconColor = 'black',
  dividerColor = 'black',
  textColor = 'black',
  dynamicbg = true,
  audioLink
}) => {
  const { t } = useTranslation(i18next.language);

  const [isPlaying, setIsPlaying] = useState(false);

  const playCircleStyle = { color: playIconColor };
  const [voiceCardAudioPlayer] = useState(new Audio());

  function playAudio(audioUrl) {
    if (!audioUrl) {
      console.warn('No audio URL provided');
      return;
    }

    try {
      voiceCardAudioPlayer.src = audioUrl();
      const playPromise = voiceCardAudioPlayer.play();

      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            setIsPlaying(true);
          })
          .catch((error) => {
            console.error('Error playing audio:', error);
            setIsPlaying(false);
          });
      }
    } catch (error) {
      console.error('Error setting up audio:', error);
      setIsPlaying(false);
    }
  }

  function stopAudio() {
    try {
      voiceCardAudioPlayer.pause();
      setIsPlaying(false);
    } catch (error) {
      console.error('Error stopping audio:', error);
    }
  }

  return (
    <Box bgcolor={dynamicbg ? `${space}.main` : '#1D1D1D'} className="ugc-voice-card-box">
      <Box className="ugc-voice-card-card1">
        <Box>
          <Typography className="ug-voice-card-typo1" color={color}>
            {t('common.voiceCard.inTheir')}
          </Typography>
          <Typography className="ug-voice-card-typo2" color={color} component={'span'}>
            <AudioIcon color={audioIconColor} />
            {t('common.voiceCard.ownWords')}
          </Typography>
        </Box>
        {isPlaying ? (
          <PauseCircleFilledIcon
            style={playCircleStyle}
            className="ugc-voice-card-playcircle"
            onClick={() => stopAudio()}
          />
        ) : (
          <PlayCircleIcon
            style={playCircleStyle}
            className="ugc-voice-card-playcircle"
            onClick={() => playAudio(audioLink)}
          />
        )}
      </Box>
      <Box className="ugc-voice-card-bottom-content-container">
        <Divider color={dividerColor} className="ugc-voice-card-divider" />
        <Box className="ugc-voice-card-people-box">
          <PeopleDetails attribution={attribution} textColor={textColor} />
        </Box>
      </Box>
    </Box>
  );
};

UgcVoiceCard.propTypes = {
  attribution: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  space: PropTypes.string.isRequired,
  audioIconColor: PropTypes.string.isRequired,
  playIconColor: PropTypes.string.isRequired,
  dividerColor: PropTypes.string.isRequired,
  textColor: PropTypes.string.isRequired,
  dynamicbg: PropTypes.bool.isRequired,
  audioLink: PropTypes.func.isRequired
};

export default UgcVoiceCard;
